var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M20 5.9v8.3L14.1 20H5.9L0 14.1V5.9L5.9 0h8.3L20 5.9zM8.5 10.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3v-4c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3v4zm2.9 4.4c-.1-.9-.9-1.6-1.7-1.5-.8.1-1.4.7-1.5 1.5-.1.9.6 1.7 1.5 1.7.9.1 1.7-.6 1.7-1.5.1-.1.1-.1 0-.2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Error.svg